<template>
  <div id="formation-bar">
    <label for="formation-select" class="--uppercase">
      {{ $t('tactics.formation.formation') }}
    </label>
    <select 
        id="formation-select"
        v-model="selectedFormation"
        @change.stop="$event.target.blur()"
        @contextmenu="$event.target.blur()"
    >
      <option 
          v-for="formation in formations.common.formations" 
          :key="formation.name"
          :value="formation"
          :disabled="formation.disabled === true"
          :class="{ hidden: formation.disabled }"
          :selected="formation.selected"
      >
        {{ formation.name }}
      </option>

      <template v-for="group in formations.categorised">
        <optgroup 
            :key="group.defenderCount" 
            :label="$tc('tactics.formations.groupNames', group.defenderCount)"
        >
          <option
              v-for="formation in group.formations"
              :key="formation.name"
              :value="formation"
              :disabled="formation.disabled === true"
              :class="{ hidden: formation.disabled }"
              :selected="formation.selected"
          >
            {{ formation.name }}
          </option>
        </optgroup>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formations: {
        common: {
          formations: [
            { value: [], name: "Custom", disabled: true },
            { value: [1, 3, 4, 6, 2, 13, 14, 16, 12, 22, 24], name: "4-4-2", selected: true },
            { value: [1, 4, 5, 6, 13, 14, 15, 16, 12, 22, 24], name: "3-5-2" },
            { value: [1, 3, 4, 6, 2, 10, 14, 16, 18, 17, 23], name: "4-1-4-1 DM Wide" },
            { value: [1, 3, 4, 6, 2, 9, 11, 15, 18, 17, 23], name: "4-1-2-3 DM Wide" },
            { value: [1, 3, 4, 6, 2, 9, 11, 14, 16, 22, 24], name: "4-2-2-2 DM Narrow" },
            { value: [1, 3, 4, 6, 2, 9, 11, 18, 20, 17, 23], name: "4-2-3-1 DM Wide" },
            { value: [1, 3, 4, 6, 2, 14, 16, 19, 20, 21, 23], name: "4-2-3-1 Narrow" },
            { value: [1, 3, 4, 6, 2, 14, 16, 18, 20, 17, 23], name: "4-2-3-1 Wide" },
            { value: [1, 3, 4, 6, 2, 13, 14, 16, 12, 20, 23], name: "4-4-1-1" },
            { value: [1, 3, 4, 6, 2, 10, 14, 16, 20, 22, 24], name: "4-4-2 Diamond Narrow" },
            { value: [1, 4, 5, 6, 8, 7, 14, 15, 16, 22, 24], name: "5-3-2 WB" },
          ]
        },
        categorised: {
          '4 defender formations': {
            defenderCount: 4,
            formations: [
              { value: [1, 3, 4, 6, 2, 10, 14, 16, 19, 21, 23], name: "4-1-2-3 DM AM Narrow" },
              { value: [1, 3, 4, 6, 2, 10, 14, 16, 19, 21, 23], name: "4123 DM AM Narrow" },
              { value: [1, 3, 4, 6, 2, 10, 14, 16, 22, 23, 24], name: "4123 DM Narrow" },
              { value: [1, 3, 4, 6, 2, 15, 19, 21, 22, 23, 24], name: "4123 Narrow" },
              { value: [1, 3, 4, 6, 2, 10, 14, 15, 16, 20, 23], name: "41311 DM AM Narrow" },
              { value: [1, 3, 4, 6, 2, 10, 13, 15, 12, 22, 24], name: "4132 DM" },
              { value: [1, 3, 4, 6, 2, 10, 14, 15, 16, 22, 24], name: "4132 DM Narrow" },
              { value: [1, 3, 4, 6, 2, 10, 13, 14, 16, 12, 23], name: "4141 DM" },
              { value: [1, 3, 4, 6, 2, 10, 14, 12, 18, 21, 23], name: "4141 DM Asymmetric AM (L)" },
              { value: [1, 3, 4, 6, 2, 10, 13, 16, 19, 17, 23], name: "4141 DM Asymmetric AM (R)" },
              { value: [1, 3, 4, 6, 2, 9, 11, 13, 12, 22, 24], name: "4222 DM" },
              { value: [1, 3, 4, 6, 2, 9, 11, 19, 21, 22, 24], name: "4222 DM AM Narrow" },
              { value: [1, 3, 4, 6, 2, 9, 11, 13, 15, 12, 23], name: "4231 DM" },
              { value: [1, 3, 4, 6, 2, 9, 11, 19, 20, 21, 23], name: "4231 DM AM Narrow" },
              { value: [1, 3, 4, 6, 2, 9, 11, 13, 15, 12, 20], name: "42310 DM" },
              { value: [1, 3, 4, 6, 2, 9, 11, 18, 17, 22, 24], name: "424 DM Wide" },
              { value: [1, 3, 4, 6, 2, 14, 16, 18, 17, 22, 24], name: "424 Wide" },
              { value: [1, 3, 4, 6, 2, 9, 11, 18, 19, 21, 17], name: "4240 DM Wide" },
              { value: [1, 3, 4, 6, 2, 14, 15, 16, 20, 22, 24], name: "4312 Narrow" },
              { value: [1, 3, 4, 6, 2, 14, 15, 16, 19, 21, 23], name: "4321 Narrow" },
              { value: [1, 3, 4, 6, 2, 14, 15, 16, 22, 23, 24], name: "433 Narrow" },
              { value: [1, 3, 4, 6, 2, 9, 11, 13, 12, 20, 23], name: "4411 2DM" },
              { value: [1, 3, 4, 6, 2, 13, 14, 15, 16, 12, 23], name: "451" },
            ]
          },
          '3 defender formations': {
            defenderCount: 3,
            formations: [
              { value: [1, 4, 5, 6, 10, 13, 15, 12, 20, 22, 24], name: "3-1-3-1-2 DM" },
              { value: [1, 4, 5, 6, 10, 13, 14, 12, 16, 22, 24], name: "3142 DM" },
              { value: [1, 4, 5, 6, 9, 11, 13, 15, 12, 22, 24], name: "3232 DM" },
              { value: [1, 4, 5, 6, 13, 14, 16, 12, 20, 22, 24], name: "3412" },
              { value: [1, 4, 5, 6, 13, 14, 16, 12, 19, 21, 23], name: "3421" },
              { value: [1, 4, 5, 6, 8, 9, 11, 7, 14, 16, 23], name: "3421 DM" },
              { value: [1, 4, 5, 6, 13, 16, 14, 12, 22, 23, 24], name: "343" },
              { value: [1, 4, 5, 6, 8, 9, 11, 7, 18, 17, 23], name: "343 DM Wide" },
            ]
          },
          '5 defender formations': {
            defenderCount: 5,
            formations: [
              { value: [1, 3, 4, 5, 6, 2, 10, 14, 16, 22, 24], name: "5-1-2-2 DM Narrow" },
              { value: [1, 4, 5, 6, 8, 10, 7, 14, 16, 22, 24], name: "5122 DM WB" },
              { value: [1, 4, 5, 6, 8, 10, 7, 14, 15, 16, 23], name: "5131 DM WB" },
              { value: [1, 4, 5, 6, 8, 7, 14, 16, 20, 22, 24], name: "5212 WB" },
              { value: [1, 3, 4, 5, 6, 2, 9, 11, 13, 12, 20], name: "52210 DM" },
              { value: [1, 3, 4, 5, 6, 2, 14, 16, 22, 23, 24], name: "523 Narrow" },
              { value: [1, 3, 4, 5, 6, 2, 13, 14, 16, 12, 23], name: "541" },
              { value: [1, 4, 5, 6, 8, 10, 7, 14, 16, 20, 23], name: "541 Diamond WB" },
              { value: [1, 4, 5, 6, 8, 7, 14, 16, 18, 17, 23], name: "541 WB Wide" }
            ]
          }
        }
      }
    };
  },

  computed: {
    allFormationCategories: function() {
      return Object.values(this.formations.categorised).concat(this.formations.common);
    },

    selectedFormation: {
      get () {
        const activePositions = 
          Object.entries(this.$store.state.positions)
            .filter(entry => entry[1].filled)
            .map(entry => parseInt(entry[0].replace("player", "")))

        for (const category of this.allFormationCategories) {
          for (const formation of category.formations) {
            if (activePositions.every((activePosition) => { return formation.value.includes(activePosition) })) {
              return formation;
            }
          }
        }
        return this.formations.common.formations[0];
      },
      set (formation) {
        for (const key of Object.keys(this.$store.state.positions)) {
          this.$store.commit("setPositionFilled", {
            position: key,
            filled: false
          });
        }
        for (const positionNumber of formation.value) {
          this.$store.commit("setPositionFilled", {
            position: "player"+positionNumber,
            filled: true
          });
        }
      }
    },
  },

  created () {
    const randomFormationIndex = Math.round((this.formations.common.formations.length - 1) * Math.random());
    this.selectedFormation = this.formations.common.formations[randomFormationIndex];
  }
}
</script>
